// extracted by mini-css-extract-plugin
export default {"noMargin":"ATMHeader_noMargin__fPXQY"};